import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from "../../components/LoadableLoading";
import {ILoadedProps, IProps} from "./interface";
import {getRealEstates, getSurveyQuestions} from "./api";

export const path = '/survey-create';

const PageSurveyCreate: React.FC<IProps> = (props) => {
    // @ts-ignore
    let loader = {
        page: () => import(`./page`),
        i18n: () => import(`./ru.json`),
        availableRealEstates: getRealEstates,
        availableSurveyQuestions: getSurveyQuestions,
    };

    const LoadableMap = Loadable.Map({
        loader: loader,
        loading: LoadableLoading,
        render(loaded: ILoadedProps): React.ReactNode {
            const Page: any = loaded.page.default;
            let availableRealEstates = loaded.availableRealEstates;
            let availableSurveyQuestions = loaded.availableSurveyQuestions;

            return (
                <Page i18n={{...loaded.i18n}}
                      availableRealEstates={availableRealEstates}
                      availableSurveyQuestions={availableSurveyQuestions}
                      {...props}
                />
            );
        }
    });

    return <LoadableMap {...props} />;
};

export default PageSurveyCreate;